import { combineReducers } from 'redux'

import invoices from './invoices'
import clients from './clients'
import suppliers from './suppliers'
import auth from './auth'
import profiles from './profiles'
import items from './items'
import meetings from './meetings'
import nationalities from './nationalities'
export default combineReducers({ invoices, clients, auth, profiles,items,meetings,suppliers, nationalities })